import React from "react";
import { mdiShapeOutline, mdiEyeOffOutline, mdiArchiveOutline } from "@mdi/js";
import HowItWorksModal from "app/components/common/HowItWorksModal";

const ROWS = [
  {
    icon: mdiShapeOutline,
    body: (
      <p>AI auto-categorizes your project content based on this structure.</p>
    ),
  },
  {
    icon: mdiArchiveOutline,
    body: (
      <p>
        The ”Other” section and subsection are fallback options for AI and
        cannot be removed.
      </p>
    ),
  },
  {
    icon: mdiEyeOffOutline,
    body: <p>Sections with no content will be hidden in the final report.</p>,
  },
];

const EditHowItWorksModal = ({ show, onHide }) => (
  <HowItWorksModal
    show={show}
    onHide={onHide}
    title="How It Works"
    rows={ROWS}
  />
);

export default EditHowItWorksModal;
